/**
 * Tells the party leader of an unhosted show what the badge is for. Core's, not a game's,
 * since a game may not know there is a show around it.
 */

import type { Snapshot } from '@gsf/contract';

export function LeaderBadge({ snapshot }: { readonly snapshot: Snapshot }) {
  if (!snapshot.you.isPartyLeader) return null;
  return (
    <div className="leader-badge">
      <span>
        <strong>You&rsquo;re steering.</strong> Nobody&rsquo;s hosting — between rounds you
        can start the next one or hold it.
      </span>
    </div>
  );
}
